import axiosClient from "@/axios";
import { AxiosPromise } from "axios";
import { SuppliersResponse } from "@/models/SuppliersResponse";
import downloadService from "@/services/download.service";

export type PerformanceReportParams = {
  date_from: string;
  date_to: string;
  supplier_ids?: string;
  country_ids?: string;
  product_names?: string;
};

// The backend names both files (customer + period), so `null` is passed as the
// extension to let the content-disposition header decide.
const performanceReportService = {
  // Only carriers with tracking data for the period, so the form cannot offer
  // one that would produce a report of zeroes.
  carriers(dateFrom: string, dateTo: string): AxiosPromise<SuppliersResponse> {
    return axiosClient.get("/performance-reports/carriers", {
      params: { date_from: dateFrom, date_to: dateTo },
    });
  },
  downloadPdf(params: PerformanceReportParams): Promise<unknown> {
    return downloadService.download(
      "/performance-reports/pdf",
      "performance_report",
      null,
      params as unknown as Record<string, string>
    );
  },
  downloadXlsx(params: PerformanceReportParams): Promise<unknown> {
    return downloadService.download(
      "/performance-reports/xlsx",
      "performance_report",
      null,
      params as unknown as Record<string, string>
    );
  },
};

export default performanceReportService;
